import React from 'react';
import PropTypes from 'prop-types';
import { Trans, useTranslation } from 'react-i18next';
import { RegionCode } from '../types';

const CustomTrans = ({
  label, region, inviting, company,
}) => {
  const { t } = useTranslation();

  switch (label) {
    case `FORM_USER_ACCOUNT.USER_ACCOUNT_DESC_${region}`:
      return (
        <Trans key={label} i18nKey={label}>
          <b>{{ company }}</b>
        </Trans>
      );
    case 'CONSENT.CONSENT_TERMS_AND_CONDITIONS':
      return (
        <Trans key={label} i18nKey={label}>
          <a href={t('COMMON.OWU')} target="_blank" rel="noreferrer">
            Terms and Conditions
          </a>
          <span style={{ color: 'red' }}>
            *
          </span>
        </Trans>
      );
    case 'CONSENT.CONSENT_TELEMATICS':
      return (
        <Trans key={label} i18nKey={label}>
          <span style={{ color: 'red' }}>
            *
          </span>
        </Trans>
      );
    case 'CONSENT.CONSENT_MONITORING_SERVICE':
    case 'CONSENT.CONSENT_MONITORING_SERVICE_PERMANENT':
      return (
        <Trans key={label} i18nKey={label}>
          <b>{{ inviting }}</b>
          <span style={{ color: 'red' }}>
            *
          </span>
        </Trans>
      );
    default:
      return <Trans key={label} i18nKey={label} />;
  }
};

export default CustomTrans;

CustomTrans.propTypes = {
  label: PropTypes.string.isRequired,
  region: PropTypes.oneOf(Object.values(RegionCode)).isRequired,
  inviting: PropTypes.string.isRequired,
  company: PropTypes.string.isRequired,
};
